import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import React, { useState, useEffect } from 'react';
import AlumnosInscritosSiguienteCiclo from './AlumnosInscritosSiguienteCiclo'
import { useForm2 } from '../../../hooks/useForm2';
import { Grid } from '@material-ui/core';

const getFreshModelObject2 = () => ({
    idusuario: 0,
    fecha: 'none',
    listaPagos: []
})

export default function AlumnosInscritosSiguienteCicloContainer(props) {

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetFormControls
    } = useForm2(getFreshModelObject2);

    return (
        <AlumnosInscritosSiguienteCiclo
            {...{
                values,
                setValues,
                errors,
                setErrors,
                handleInputChange,
                resetFormControls
            }}
        />
    )
}
